import React from "react";
import PropTypes from "prop-types";
// react plugin for creating charts
import ChartistGraph from "react-chartist";
import {
  AddAlert,
  LocalOffer,
  Update,
  AccessTime,
  Accessibility
} from "@material-ui/icons";

import Grid from "@material-ui/core/Grid";

import {
  StatsCard,
  ChartCard,
  ItemGrid
} from "../../components";

import { connect } from 'react-redux';

import moment from 'moment';

import { loadUsers } from '../Users/reducer/actions';
import { loadNotifications } from '../Notifications/reducer/actions';

class Dashboard extends React.Component {
  state = {
    value: 0
  };

  componentWillMount() {
    this.props.loadUsers();
    this.props.loadNotifications(() => null, () => null);
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleChangeIndex = index => {
    this.setState({ value: index });
  };

  getNotificationData() {

    let startDates = [];

    const { notifications } = this.props;

    for (let i = 11; i >= 0; i--) {
      startDates = [...startDates, moment().subtract(i, 'month').format("YYYY-MM-01")];
    }

    return {
    labels: startDates.map(v => moment(v).format('MMM')),
    series: [
      startDates.map(v => notifications.filter(n => moment(n.date).isAfter(moment(v)) && moment(n.date).isBefore(moment(v).add(1, 'month'))).length),
    ]
  }
  }

  render() {

    const notificationData = this.getNotificationData();
    const maxNotification = notificationData.series[0].reduce((p,v) => Math.max(p,v), 0);

    const lastNotification = this.props.notifications.reduce((p, {date}) => date && (p == null || moment(date).isAfter(moment(p))) ? date : p, null);

    const lastNotificationText = lastNotification != null ? moment(lastNotification).fromNow() : 'never';

    return (
      <div>
        <Grid container>
          <ItemGrid xs={12} sm={4} md={4}>
            <StatsCard
              icon={AddAlert}
              iconColor="red"
              title="Notifications"
              description={this.props.notifications.length || ' '}
              statIcon={LocalOffer}
              statText="Tracked from Firebase"
            />
          </ItemGrid>
          <ItemGrid xs={12} sm={4} md={4}>
            <StatsCard
              icon={Accessibility}
              iconColor="blue"
              title="Total Users"
              description={this.props.users.length || ' '}
              statIcon={Update}
              statText="Just Updated"
            />
          </ItemGrid>
        </Grid>
        <Grid container>
          <ItemGrid xs={12} sm={12} md={4}>
            <ChartCard
              chart={
                <ChartistGraph
                  className="ct-chart"
                  data={this.getNotificationData()}
                  type="Bar"
                  options={{
                    axisX: {
                      showGrid: false
                    },
                    low: 0,
                    high: maxNotification + 1,
                    chartPadding: {
                      top: 0,
                      right: 5,
                      bottom: 0,
                      left: 0
                    }
                  }}
                  responsiveOptions={[
                    [
                      "screen and (max-width: 640px)",
                      {
                        seriesBarDistance: 5,
                        axisX: {
                          labelInterpolationFnc: function(value) {
                            return value[0];
                          }
                        }
                      }
                    ]
                  ]}
                  listener={{draw: function(data) {
                    if (data.type === "bar") {
                      data.element.animate({
                        opacity: {
                          begin: (data.index + 1) * 80,
                          dur: 500,
                          from: 0,
                          to: 1,
                          easing: "ease"
                        }
                      });
                    }
                  }}}
                />
              }
              chartColor="orange"
              title="Notifications"
              text="Statistics for sent notifications"
              statIcon={AccessTime}
              statText={`last notification sent ${lastNotificationText}`}
            />
          </ItemGrid>
        </Grid>
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  users: state.userReducer.users,
  notifications: state.notificationReducer.notifications,
});

const mapDispatchToProps = {
  loadUsers,
  loadNotifications,
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
